export const hardProblems = [
    {
        id: 4,
        title: "Median of Two Sorted Arrays",
        solution_src: ""
    },
    {
        id: 23,
        title: "Merge k Sorted Lists",
        solution_src: "https://leetcode.com/problems/merge-k-sorted-lists/discuss/1182290/Simple-to-Understand-C%2B%2B-Solution"
    }
]
